const kefuRouter = {
  path: '',
  component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/layout'),
  meta: { title: '客服中心' },
  children: [
    {
      path: '/kefu', // 客服首页
      name: 'kefu',
      meta: { title: '客服中心' },
      component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/mainPage')
    },
    {
      path: '/kefuArticle', // 文章列表
      name: 'Article',
      meta: { title: '客服中心' },
      component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/search'),
      redirect: 'kefuArticle/list',
      children: [
        {
          path: 'list/:type',
          name: 'list',
          meta: { title: '新客服中心' },
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/article/list')
        },
        {
          path: 'guide',
          name: 'kefuGuide',
          meta: { title: '平台合规管理规则参考' },
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/article/guide')
        },
        {
          path: 'list',
          name: 'List',
          meta: { title: '客服中心' },
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/article/list')
        },
        {
          path: 'detail/:id',
          name: 'detail',
          meta: { title: '客服中心' },
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/article/detail')
        }
      ]
    },
    {
      path: '/kefuVideo', // 视频列表
      name: 'kefuVideo',
      component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/video/index'),
      redirect: 'kefuVideo/list',
      children: [
        {
          path: 'list',
          name: 'list',
          meta: { title: '客服中心' },
          component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/video/list')
        },
        {
          path: 'detail/:id',
          name: 'detail',
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/video/detail')
        }
      ]
    },

    {
      path: '/feedback', // 新建工单
      name: 'feedback',
      component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/feedback/index'),
      redirect: 'feedback/index',
      children: [
        {
          path: 'index',
          name: 'feedbackNew',
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/feedback/new')
        },
        {
          path: 'success',
          name: 'feedbackSuccess',
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/feedback/success')
        }
      ]
    },

    {
      path: '/accountAppeal', // 账号投诉
      name: 'accountAppeal',
      component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/accountAppeal/index')
    },
    {
      path: '/guide', // 新手指南
      name: 'Guide',
      component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/search'),
      redirect: 'guide/list',
      children: [
        {
          path: 'list',
          name: 'list',
          component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/guide/list')
        },
        {
          path: 'typeList',
          name: 'typeList',
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/guide/typeList')
        }
      ]
    },
    {
      path: '/mainServices', // 客服在身边
      name: 'mainServices',
      meta: { title: '客服中心' },
      redirect: 'mainServices/list',
      component: () => import(/* webpackChunkName: "service-new" */ '@/pages/kefu/search'),
      children: [
        {
          path: 'list',
          name: 'list',
          component: () =>
            import(/* webpackChunkName: "service-new" */ '@/pages/kefu/components/mainServices')
        }
      ]
    }
    // {
    //   path: '/newFeedback', // 新建工单
    //   name: 'NewFeedback',
    //   component: () => import('@/pages/newFeedback/index'),
    //   redirect: 'newFeedback/index',
    //   children: [{
    //     path: 'index',
    //     name: 'NewFeedbackNew',
    //     component: () => import('@/pages/newFeedback/new')
    //   },
    //   {
    //     path: 'success',
    //     name: 'NewFeedbackSuccess',
    //     component: () => import('@/pages/newFeedback/success')
    //   }
    //   ]
    // }
  ]
}

export default kefuRouter
